import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App";
import { AccountGate } from "./features/account/AccountGate";
import { installGlobalErrorLogging, reportClientError } from "./application/client-error-logger";
import { recordVisit } from "./application/visit-analytics";
import "./ui/global.css";

installGlobalErrorLogging();
recordVisit();

const root = document.getElementById("root");
if (!root) throw new Error("Root element was not found");

const renderApp = async () => {
  const preview = new URLSearchParams(window.location.search).get("preview");
  if (import.meta.env.DEV && preview === "lists-voice") {
    const { ListsVoicePreview } = await import("./dev/lists-voice-preview");
    createRoot(root).render(<ListsVoicePreview />);
    return;
  }
  if (import.meta.env.DEV && preview === "duplicate-food") {
    const { DuplicateFoodPreview } = await import("./dev/duplicate-food-preview");
    createRoot(root).render(<DuplicateFoodPreview />);
    return;
  }
  if (import.meta.env.DEV && preview === "statistics") {
    const { StatisticsPreview } = await import("./dev/statistics-preview");
    createRoot(root).render(<StatisticsPreview />);
    return;
  }
  const previewDraft = import.meta.env.DEV && preview === "meal-editor"
    ? (await import("./dev/meal-editor-fixture")).mealEditorFixture
    : import.meta.env.DEV && preview === "food-settings" ? (await import("./dev/food-settings-fixture")).foodSettingsFixture
    : import.meta.env.DEV && preview === "category-settings" ? (await import("./dev/category-settings-fixture")).categorySettingsFixture
    : import.meta.env.DEV && preview === "long-meal" ? (await import("./dev/long-meal-fixture")).longMealFixture
    : import.meta.env.DEV && preview === "unknown-food" ? (await import("./dev/unknown-food-fixture")).unknownFoodFixture : null;
  const previewAssistantState = import.meta.env.DEV && preview === "goal-summary"
    ? (await import("./dev/assistant-summary-fixture")).assistantSummaryFixture
    : null;
  if (import.meta.env.DEV && preview) {
    const previewAccount = { userId: null, identity: null, busy: false, error: '', login: async () => {}, logout: async () => {}, retry: async () => {} };
    createRoot(root).render(<StrictMode><App account={previewAccount} previewDraft={previewDraft} previewAssistantState={previewAssistantState} /></StrictMode>);
    return;
  }
  createRoot(root).render(<StrictMode><AccountGate>{account => <App account={account} previewDraft={previewDraft} previewAssistantState={previewAssistantState} />}</AccountGate></StrictMode>);
};
void renderApp();

window.addEventListener("load", () => {
  window.setTimeout(() => {
    const splash = document.getElementById("pwa-splash");
    splash?.classList.add("is-hidden");
    window.setTimeout(() => splash?.remove(), 250);
  }, 500);
});

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const hadController = Boolean(navigator.serviceWorker.controller);
    let reloading = false;
    if (hadController) navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" })
      .then(registration => registration.update())
      .catch(error => {
        console.error("YumNote service worker registration failed", error);
        reportClientError(error, { area: "pwa", action: "service_worker_registration" });
      });
  });
}
